import React, { useState, useEffect } from 'react';
import { getRutas, crearRuta, eliminarRuta } from '../lib/db';

export default function Rutas({ empresaId }) {
  const [rutas, setRutas] = useState([]);
  const [showNueva, setShowNueva] = useState(false);
  const [filtro, setFiltro] = useState('');
  const [nueva, setNueva] = useState({ lugar_carga: '', direccion_carga: '', lugar_descarga: '', direccion_descarga: '' });
  const [showConfirm, setShowConfirm] = useState(null);

  useEffect(() => {
    if (!empresaId) return;
    getRutas(empresaId).then(({ data }) => { if (data) setRutas(data); });
  }, [empresaId]);

  const agregar = async () => {
    if (!nueva.lugar_carga || !nueva.lugar_descarga) return;
    const { data } = await crearRuta({ empresa_id: empresaId, ...nueva });
    if (data) setRutas([data, ...rutas]);
    setNueva({ lugar_carga: '', direccion_carga: '', lugar_descarga: '', direccion_descarga: '' });
    setShowNueva(false);
  };

  const eliminar = async (id) => {
    await eliminarRuta(id);
    setRutas(rutas.filter(r => r.id !== id));
    setShowConfirm(null);
  };

  const rutaLabel = (r) => {
    const origen = r.direccion_carga ? `${r.lugar_carga} · ${r.direccion_carga}` : r.lugar_carga;
    const destino = r.direccion_descarga ? `${r.lugar_descarga} · ${r.direccion_descarga}` : r.lugar_descarga;
    return `${origen} → ${destino}`;
  };

  const rutasFiltradas = rutas.filter(r =>
    !filtro ||
    r.lugar_carga?.toLowerCase().includes(filtro.toLowerCase()) ||
    r.lugar_descarga?.toLowerCase().includes(filtro.toLowerCase()) ||
    r.direccion_carga?.toLowerCase().includes(filtro.toLowerCase()) ||
    r.direccion_descarga?.toLowerCase().includes(filtro.toLowerCase())
  );

  const s = {
    card: { background: '#111318', border: '1px solid #222730', borderRadius: '10px', padding: '24px', marginBottom: '20px' },
    label: { fontSize: '12px', color: '#9ca3af', display: 'block', marginBottom: '6px' },
    input: { width: '100%', background: '#181c24', border: '1px solid #222730', borderRadius: '6px', padding: '10px 12px', color: '#e8eaf0', fontSize: '13px', boxSizing: 'border-box' },
    inputVerde: { width: '100%', background: '#181c24', border: '1px solid #00e5a0', borderRadius: '6px', padding: '10px 12px', color: '#e8eaf0', fontSize: '13px', boxSizing: 'border-box' },
    btnGreen: { background: '#00e5a0', color: '#000', border: 'none', borderRadius: '6px', padding: '8px 16px', fontSize: '13px', fontWeight: '700', cursor: 'pointer' },
    btnOutline: { background: 'transparent', border: '1px solid #222730', color: '#9ca3af', borderRadius: '6px', padding: '8px 16px', fontSize: '13px', cursor: 'pointer' },
  };

  return (
    <div style={{ padding: '28px 32px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
        <div>
          <h2 style={{ fontSize: '20px', fontWeight: '700', color: '#ffffff', marginBottom: '4px' }}>Rutas</h2>
          <div style={{ fontSize: '13px', color: '#6b7280' }}>{rutas.length} rutas registradas</div>
        </div>
        <button onClick={() => setShowNueva(true)} style={s.btnGreen}>+ Nueva ruta</button>
      </div>

      <div style={{ marginBottom: '20px' }}>
        <input value={filtro} onChange={e => setFiltro(e.target.value)} placeholder="Buscar por lugar de carga, descarga o dirección..."
          style={{ ...s.input, maxWidth: '400px' }} />
      </div>

      {showNueva && (
        <div style={{ ...s.card, border: '1px solid #00e5a0', marginBottom: '24px' }}>
          <div style={{ fontSize: '14px', fontWeight: '600', color: '#ffffff', marginBottom: '20px' }}>Nueva Ruta</div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '24px' }}>
            <div>
              <div style={{ fontSize: '11px', color: '#00e5a0', textTransform: 'uppercase', letterSpacing: '2px', fontWeight: '600', marginBottom: '12px' }}>📦 Lugar de Carga</div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                <div>
                  <label style={s.label}>Nombre del lugar *</label>
                  <input value={nueva.lugar_carga} onChange={e => setNueva({...nueva, lugar_carga: e.target.value})}
                    placeholder="Ej: Industrias ABC" style={s.inputVerde} />
                </div>
                <div>
                  <label style={s.label}>Dirección</label>
                  <input value={nueva.direccion_carga} onChange={e => setNueva({...nueva, direccion_carga: e.target.value})}
                    placeholder="Ej: Calle Azcapotzalco 123" style={s.inputVerde} />
                </div>
              </div>
            </div>
            <div>
              <div style={{ fontSize: '11px', color: '#3b82f6', textTransform: 'uppercase', letterSpacing: '2px', fontWeight: '600', marginBottom: '12px' }}>🏁 Lugar de Descarga</div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                <div>
                  <label style={s.label}>Nombre del lugar *</label>
                  <input value={nueva.lugar_descarga} onChange={e => setNueva({...nueva, lugar_descarga: e.target.value})}
                    placeholder="Ej: Industrias ABC" style={s.inputVerde} />
                </div>
                <div>
                  <label style={s.label}>Dirección</label>
                  <input value={nueva.direccion_descarga} onChange={e => setNueva({...nueva, direccion_descarga: e.target.value})}
                    placeholder="Ej: Calle Lagos 456" style={s.inputVerde} />
                </div>
              </div>
            </div>
          </div>
          <div style={{ marginTop: '20px', padding: '12px 16px', background: 'rgba(0,229,160,0.05)', border: '1px solid rgba(0,229,160,0.1)', borderRadius: '8px', fontSize: '12px', color: '#6b7280' }}>
            Vista previa: <span style={{ color: '#e8eaf0' }}>
              {nueva.lugar_carga || '?'}{nueva.direccion_carga ? ` · ${nueva.direccion_carga}` : ''} → {nueva.lugar_descarga || '?'}{nueva.direccion_descarga ? ` · ${nueva.direccion_descarga}` : ''}
            </span>
          </div>
          <div style={{ display: 'flex', gap: '8px', marginTop: '16px' }}>
            <button onClick={agregar} style={s.btnGreen}>Guardar ruta</button>
            <button onClick={() => { setShowNueva(false); setNueva({ lugar_carga: '', direccion_carga: '', lugar_descarga: '', direccion_descarga: '' }); }} style={s.btnOutline}>Cancelar</button>
          </div>
        </div>
      )}

      <div style={{ background: '#111318', border: '1px solid #222730', borderRadius: '10px', overflow: 'hidden' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr>
              {['Lugar de carga', 'Dirección carga', 'Lugar de descarga', 'Dirección descarga', 'Ruta completa', ''].map(h => (
                <th key={h} style={{ fontSize: '10px', textTransform: 'uppercase', letterSpacing: '2px', color: '#6b7280', padding: '12px 20px', textAlign: 'left', borderBottom: '1px solid #222730', fontWeight: '600' }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rutasFiltradas.map((r, i) => (
              <tr key={r.id} style={{ background: i % 2 === 0 ? 'transparent' : '#0d1117' }}>
                <td style={{ padding: '12px 20px', fontSize: '13px', color: '#e8eaf0', fontWeight: '500' }}>{r.lugar_carga}</td>
                <td style={{ padding: '12px 20px', fontSize: '12px', color: '#6b7280' }}>{r.direccion_carga || '—'}</td>
                <td style={{ padding: '12px 20px', fontSize: '13px', color: '#e8eaf0', fontWeight: '500' }}>{r.lugar_descarga}</td>
                <td style={{ padding: '12px 20px', fontSize: '12px', color: '#6b7280' }}>{r.direccion_descarga || '—'}</td>
                <td style={{ padding: '12px 20px', fontSize: '12px', color: '#9ca3af', fontStyle: 'italic' }}>{rutaLabel(r)}</td>
                <td style={{ padding: '12px 20px' }}>
                  {showConfirm === r.id ? (
                    <div style={{ display: 'flex', gap: '6px' }}>
                      <button onClick={() => eliminar(r.id)} style={{ background: '#ef4444', color: '#fff', border: 'none', borderRadius: '6px', padding: '4px 10px', fontSize: '11px', fontWeight: '700', cursor: 'pointer' }}>Confirmar</button>
                      <button onClick={() => setShowConfirm(null)} style={{ background: 'transparent', border: '1px solid #222730', color: '#9ca3af', borderRadius: '6px', padding: '4px 8px', fontSize: '11px', cursor: 'pointer' }}>Cancelar</button>
                    </div>
                  ) : (
                    <button onClick={() => setShowConfirm(r.id)} style={{ background: 'transparent', border: 'none', color: '#ef4444', cursor: 'pointer', fontSize: '14px' }}>🗑️</button>
                  )}
                </td>
              </tr>
            ))}
            {rutasFiltradas.length === 0 && (
              <tr><td colSpan="6" style={{ padding: '32px', textAlign: 'center', color: '#6b7280', fontSize: '13px' }}>
                {rutas.length === 0 ? 'Sin rutas registradas. Crea una para usarla en viajes.' : 'Sin resultados para tu búsqueda.'}
              </td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
